import { Component, OnInit, Input } from '@angular/core';
import { CaseService } from '../../../shared/services/case.service';
import { LookupsService } from '../../../shared/services/lookups.service';
import { UntypedFormBuilder, FormControl, Validators, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { faPlus, faTrashAlt, faCalendarDay, faHistory } from '@fortawesome/pro-light-svg-icons';
import { DateTime } from 'luxon';
import { LettersService } from '../../../shared/services/letters.service';
import { ComparerService } from 'src/app/shared/utility/comparer';
import { AuditService } from '../../../shared/services/audit.service';
import { CorrespondenceTimelineService } from '../../../shared/services/correspondence-timeline.service';
import { AuditFormComponent } from '../../audit-form/audit-form.component';
import { SelectConsultantComponent } from '../../../calendar/select-consultant/select-consultant.component';
import { KeyDatesComponent } from '../key-dates/key-dates.component';
import { ModalService } from 'src/app/shared/services/modal.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-mortgage-details',
  templateUrl: './mortgage-details.component.html',
  styleUrls: ['./mortgage-details.component.scss']
})
export class MortgageDetailsComponent implements OnInit {

  @Input() caseId: number;
  @Input() caseOnHold: boolean = false;

  viewInit = false;

  maxDate: Date = new Date();
  minDate: Date = new Date();

  faPlus = faPlus;
  faTrashAlt = faTrashAlt;
  faHistory = faHistory;
  faCalendarDay = faCalendarDay;

  externalConsultants:any[] = [];
  lenders:any[] = [];
  lendersSolicitors:any[] = [];
  lendersSolicitorEmails:any[] = [];

  loaded: boolean = false;
  generatingLetters: boolean = false;

  occupierIndex: number = 0;

  //occupiersGroup: any;

  mortgageDetails = this.fb.group({
    id: [],
    caseId: [],
    lenderId: [],
    lendersSolicitorId: [],
    lenderSolicitorReference: '',
    otherLendersSolicitor: [],
    otherLendersSolicitorEmail: [],
    lendersSolicitorEmailId: [],
    otherLender: [],
    offerExpiryDate: [],
    nameOfProduct: [],
    fullLoanAmount: [],
    drawdownAvailable: [],
    drawdownAvailableDetails: [],
    cashbackAvailable: [],
    cashbackAvailableDetails: [],
    fixedInterestRate: [],
    propertyVacatedLength: [],
    termOfMortgage: [],
    agreedInterestRepayment: [],
    agreedInterestRepaymentDetails: [],
    anyOccupiers: [],
    occupiers: this.fb.array([]),
    buildingInsuranceSumRequired: [],
    lendersInterestNotedRequired: [],
    lendersInterestNotedRequiredDetails: [],
    hasSpecialConditions: [],
    specialConditions: this.fb.array([]),
    externalConsultantId: [],
    contributionToLegalFees: [],
    contributionToLegalFeesDetails: [],
    finalAmountReleased: []
  }, { });

  initialDetails = this.fb.group({
    id: [],
    caseId: [],
    lenderId: [],
    lendersSolicitorId: [],
    lenderSolicitorReference: '',
    otherLendersSolicitor: [],
    otherLendersSolicitorEmail: [],
    lendersSolicitorEmailId: [],
    otherLender: [],
    offerExpiryDate: [],
    nameOfProduct: [],
    fullLoanAmount: [],
    drawdownAvailable: [],
    drawdownAvailableDetails: [],
    cashbackAvailable: [],
    cashbackAvailableDetails: [],
    fixedInterestRate: [],
    propertyVacatedLength: [],
    termOfMortgage: [],
    agreedInterestRepayment: [],
    agreedInterestRepaymentDetails: [],
    anyOccupiers: [],
    occupiers: this.fb.array([]),
    buildingInsuranceSumRequired: [],
    lendersInterestNotedRequired: [],
    lendersInterestNotedRequiredDetails: [],
    hasSpecialConditions: [],
    specialConditions: this.fb.array([]),
    externalConsultantId: [],
    contributionToLegalFees: [],
    contributionToLegalFeesDetails: [],
    finalAmountReleased: []
  }, { });



  constructor(
              private caseService: CaseService,
              private fb: UntypedFormBuilder,
              private lookupsService: LookupsService,
              private lettersService: LettersService,
              private comp: ComparerService,
              private auditService: AuditService,
              public activeModal: NgbActiveModal,
              private correspondenceTimelineService: CorrespondenceTimelineService,
              private modalService: ModalService) {

  }

  ngOnInit(): void {
    this.loadDetails();
  }

  ngAfterContentInit() : void {
    this.viewInit = true;
    //this.loadDetails();
  }

  loadDetails(): void{

    this.loaded = false;
    this.caseService.getEquityReleaseMortgageDetails(this.caseId).subscribe(response => {

      // Clear arrays before repopulating
      while (this.occupiers.length) {
        this.occupiers.removeAt(0);
      }
      while (this.specialConditions.length) {
        this.specialConditions.removeAt(0);
      }

      this.mortgageDetails.patchValue(response.mortgageDetails);

      this.lookupsService.getExternalConsultants().subscribe(result => {
        this.externalConsultants = result;
      });

      this.lookupsService.getLenders().subscribe(result => {
        this.lenders = result.sort((a, b) => a.name.localeCompare(b.name));
      });

      this.lookupsService.getLendersSolicitors().subscribe(result => {
        this.lendersSolicitors = result.sort((a, b) => a.name.localeCompare(b.name));
      });

      this.lookupsService.getLendersSolicitorEmails().subscribe(result => {

          this.lendersSolicitorEmails = result
              .filter(ls => ls.lendersSolicitorId == this.mortgageDetails.controls['lendersSolicitorId'].value)
              .sort((a, b) => a.emailAddress.localeCompare(b.emailAddress));
      });

      response.mortgageDetails.occupiers.forEach((element : any) => {
        const occupier = this.newOcc(element.idx);
        occupier.patchValue(element);
        this.occupiers.push(occupier);
      });

      response.mortgageDetails.specialConditions.forEach((element : any) => {
        const sc = this.newSC();
        sc.patchValue(element);
        this.specialConditions.push(sc);
      });

      this.minDate = DateTime.local().toJSDate();
      this.maxDate = DateTime.local().plus({years : 10}).toJSDate();

      this.initialDetails.patchValue(response.mortgageDetails);

      this.loaded = true;

    });
  }



  get occupiers() : UntypedFormArray {
   return this.mortgageDetails.get('occupiers') as UntypedFormArray
  }

  get specialConditions () {
    return this.mortgageDetails.get('specialConditions') as UntypedFormArray
  }

  newOcc(idx: number) : UntypedFormGroup{
    return this.fb.group({
      id : [],
      occupierName:'',
      occupierDOB: null,
      occupierRelationshipToClient: '',
      idx: idx
    })
  }

  addOcc() {

    var idx = 0;

    this.occupiers.controls.forEach((element, index) => {

      if(element?.get("idx")?.value !== null && element?.get("idx")?.value > idx)
        idx = element?.get("idx")?.value;
    });

    this.occupiers.push(this.newOcc(idx + 1));
  }

  removeOcc(i:number) {
    this.occupiers.removeAt(i);
    this.updateField();
  }

  newSC() : UntypedFormGroup{
    return this.fb.group({
      id : [],
      specialCondition:''
    })
  }

  addSC() {
    this.specialConditions.push(this.newSC());
  }

  removeSC(i:number) {
    this.specialConditions.removeAt(i);
    this.updateField();
  }

  updateField(reloadEntityType? : string){

    this.caseService.updateEquityReleaseMortgageDetails(this.mortgageDetails.value).subscribe((response : any) => {

    }, (error : any) => {

        /*
        var errorMessage = "Failed to update case";
        if(error.error !== null && error.error.message !== undefined)
        {
        errorMessage = error.error.message;
        }*/

    });
  }

  createLetters(){

    this.generatingLetters = true;

    this.lettersService.generateLettersForGroup(this.caseId, 2).subscribe((response : any) => {
      this.correspondenceTimelineService.refreshCaseTimeline.next();
      this.close();
    }, (error : any) => {


    });
  }

  close(){

    if(this.comp.objectsDifferent(this.initialDetails.value, this.mortgageDetails.value))
    {
      this.auditService.auditForm(this.caseId, 'MortgageDetails', this.initialDetails.value, this.mortgageDetails.value).subscribe((response : any) => {
        this.activeModal.close(true);
        this.caseService.refreshCase.next();
      });
    }
    else
      this.activeModal.dismiss();
  }

  openAuditForForm(){

    const modalRef = this.modalService.openWithOptions(AuditFormComponent, {size: 'xl'});
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.formName = "MortgageDetails";

  }

  selectConsultant(){

    const modalRef = this.modalService.openXLModal(SelectConsultantComponent);
            
    modalRef.componentInstance.caseId = this.caseId;

    modalRef.result.then(
        (result) => {
          if (result) {
            this.mortgageDetails.controls['externalConsultantId'].patchValue(result.externalConsultantId);
            this.updateField();
          }
    },
    () => {} // dismissed - do nothing
    );
  }

  openKeyDates() {

    const modalRef = this.modalService.openWithOptions(KeyDatesComponent, {size: 'lg', scrollable: true});
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.readOnly= this.caseOnHold;
    modalRef.componentInstance.caseTypeId = 1;

    modalRef.result.then(
      (result) => {
       if(result)
       {
          if (result == "fileClosed")
            window.location.reload();
          else
            this.loadDetails();
       }},
        () => {
          this.loadDetails();
        }
    );  
  }

  updateSolEmails(){

    this.lookupsService.getLendersSolicitorEmails().subscribe(result => {
      this.lendersSolicitorEmails = result;

      this.lendersSolicitorEmails = this.lendersSolicitorEmails.filter( ls => ls.lendersSolicitorId ==  this.mortgageDetails.controls['lendersSolicitorId'].value);
    });


  }

}
